export class HomeUrlBuilder {
  static root() {
    return '/app/home';
  }
}
